import React from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from 'react-use';

import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { RoutedStepProps } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';
import { useGetClaimGroupConfirmation } from '@/view/app/hooks/useGetClaimGroupConfirmation';
import { useGetSolutionsByClaim } from '@/view/app/hooks/useGetSolutionsByClaim';

import { IrshStepValues } from '../IrshPages.types';

import { ClaimGroupSolution } from './ClaimGroupSolution/ClaimGroupSolution';
import messages from './messages';

const ClaimGroupSolutionPage: React.FC<RoutedStepProps<IrshStepValues>> = ({
  onPreviousStep,
  onNextStep,
}) => {
  useTitle(buildPageTitle([messages.claimGroupSolutionTitlePage]));

  const { claimGroupId } = useParams<{ claimGroupId: string }>();

  const { solutions } = useGetSolutionsByClaim({
    claimGroupId,
  });

  const { isLoading } = useGetClaimGroupConfirmation({
    claimGroupId,
  });

  if (!solutions || isLoading) {
    return <BaseLoader />;
  }

  return (
    <ClaimGroupSolution
      onPreviousStep={onPreviousStep}
      onNextStep={onNextStep}
    />
  );
};

export default ClaimGroupSolutionPage;
